import "./EditedFeatures.css";

import { FeatureWithChanges } from "../../../utils/newVersioningUtils";
import EditedFeaturePanelForPlan from "./EditedFeaturePanelForPlan";
import NfsButton from "../../genericComponents/NfsButton/NfsButton";
import Loader from "../../genericComponents/Loader/Loader";
import type { ResourceHandle } from "@arcgis/core/core/Handles";

interface EditedFeaturesForPlanProps {
    featuresAddedToJob: FeatureWithChanges[];
    refreshFeaturesAddedToJob: () => Promise<void>;
    isLoadingChanges: boolean;
    storeHighlightHandle: (handle: ResourceHandle | null) => void;
    clearHighlightedFeatures: () => void;
}

const EditedFeaturesForPlan = (props: EditedFeaturesForPlanProps) => {
    const renderEditedFeatures = () => {
        const changeList: React.JSX.Element[] = [];
        for (let featureWithChange of props.featuresAddedToJob) {
            changeList.push(
                <EditedFeaturePanelForPlan
                    key={`${featureWithChange.mainFeature.layerId}-${featureWithChange.mainFeature.objectId}`}
                    editedFeature={featureWithChange}
                    storeHighlightHandle={props.storeHighlightHandle}
                    clearHighlightedFeatures={props.clearHighlightedFeatures}
                />
            );
        }

        if (changeList.length === 0 && !props.isLoadingChanges) {
            return <div className="edited-features-no-changes">Ingen endringer funnet</div>;
        }

        return changeList;
    };

    const refreshFeatures = async () => {
        await props.refreshFeaturesAddedToJob();
    };

    return (
        <div className="edited-features w-100">
            <span className="text-center">Objekter knyttet til jobben:</span>
            <NfsButton disabled={props.isLoadingChanges} onClick={refreshFeatures}>
                <span>{props.isLoadingChanges ? "Laster..." : "Se etter nye endringer"}</span>
                {props.isLoadingChanges && <Loader inline size={24} />}
            </NfsButton>
            <div className="edited-features-body">
                <div className="edited-features-content w-100 small-gap">{renderEditedFeatures()}</div>
            </div>
        </div>
    );
};

export default EditedFeaturesForPlan;
